import { Modal, message, Input, Form, Row, Col, Radio, Select } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ReactElement } from "react";
import _, { divide } from "lodash";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { RootDispatch } from "../../app/store";
import { getUserList } from "../user/userSlice";

export const SettingModel = (props: {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}): ReactElement => {
  const [form] = Form.useForm();

  const dispatch = useDispatch<RootDispatch>()

  const [userList, setUserList] = useState<any>()

  useEffect(() => {
    if (props.visible) {
      getPatientList()
    }
  }, [props.visible])

  const getPatientList = (name?: string, ids?: any) => {
    dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
      .then(unwrapResult)
      .then((res: any) => {
        setUserList(res?.items)
      })
  }
  return (
    <Modal
      title='设置'
      width='600px'
      okText='确定'
      visible={props.visible}
      onOk={() => {
        props.onOk()
      }}
      onCancel={() => {
        props.onCancel()
      }}
      bodyStyle={{ height: '150px', overflowY: 'auto' }}
    >
      <Form
        form={form}
      >
        <Col span={24}>
          <Form.Item name='tenantIds'  label='允许退费操作人员'>
            <Select
              allowClear
              mode='multiple'
              placeholder='请选择'
            >
              {userList?.map((d: any) => (
                <Select.Option key={d.id} value={d.id}>
                  {d.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Form>
    </Modal>
  )
};
